<div class="pagination">
  <a [ngClass]="{'disable': currentPageNo==0}" (click)="emitGotoPage(0)"><mat-icon
      class="page_icon">first_page</mat-icon></a>

  <a [ngClass]="{'disable': currentPageNo==0}" (click)="emitGotoPage(currentPageNo-1)">Prev</a>
  <div *ngFor="let pageNo of pagenos">
    <a [ngClass]="{'active': (currentPageNo)==pageNo}" (click)="emitGotoPage(pageNo)">{{pageNo=='.'? pageNo:
      pageNo+1}}</a>
  </div>

  <a [ngClass]="{'disable': currentPageNo==size-1}" (click)="emitGotoPage(currentPageNo+1)">Next</a>
  <a [ngClass]="{'disable': currentPageNo==size-1}" (click)="emitGotoPage(pagenos[pagenos.length-1])"><mat-icon
      class="page_icon">last_page</mat-icon></a>
</div>